/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
    // Локальные переменные
    const module = this;
    module.initedSwipers = {}

    const Settings = {
        global: {
            slidesPerView: "auto",
            simulateTouch: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderTrigger = swiperContainer.closest("[data-lazy-function='slider']");
                    const sliderName = swiperContainer.getAttribute("data-slider-name") || "global";

                    if (!module.initedSwipers.hasOwnProperty(sliderName)) {
                        module.initedSwipers[sliderName] = swiper;
                    }
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        sliderTrigger: sliderTrigger,
                        sliderName: sliderName,
                    }
                }
            },

            breakpoints: {
                1024: {
                    slidesPerView: 3,
                }
            }
        },

        test: {
            slidesPerView: 1,
            simulateTouch: false,
            allowTouchMove: false,
            keyboard: {
                enabled: false,
                onlyInViewport: false
            },
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            spaceBetween: 0,
            speed: 400,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }

                    swiper.params.custom = {
                        requested: false
                    }
                },

                slideChange: function () {
                    const swiper = this;

                    const activeSlide = swiper.slides[swiper.activeIndex];
                    const inputWithNextStepExtraLabel = activeSlide.querySelector('[data-next-step-extra-label]');

                    if (inputWithNextStepExtraLabel) {
                        const nextSlide = swiper.slides[swiper.activeIndex + 1];
                        nextSlide.classList.remove('_show-extra-label');
                    }
                },
            },
        },

        composition: {
            slidesPerView: "auto",
            freeModeMomentum: false,
            speed: 500,
            // simulateTouch: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                },
            },
        },

        useProblem: {
            slidesPerView: "auto",
            freeModeMomentum: false,
            speed: 500,
            // simulateTouch: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                },
            },
        },

        actionProblem: {
            slidesPerView: "auto",
            freeModeMomentum: false,
            speed: 500,
            // simulateTouch: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                },
            },
        },
    };

    const getSettings = function (slidersSettingsKey) {
        return Settings[slidersSettingsKey];
    };

    module.getSettings = getSettings;
});